import { useCallback } from "react";

import { ContextSuggestions, searchContextSuggestionsDictionary } from "shared/Context/constants";
import useTypedContext from "hooks/useTypedContext";
import { ApplyFiltersContext } from "components/Filters";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Context } from "types/generated";

import useContextsAnalytics from "../../useContextsAnalytics";

const ContextsTableLabelsCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<Context>) => {
  const { applyLabelFilter, applyFilter } = useTypedContext(ApplyFiltersContext);

  const trackAnalytics = useContextsAnalytics();

  const handleApplyLabelFilter = useCallback(
    (value: string) => {
      trackAnalytics("Label clicked", { type: ContextSuggestions.Label });
      applyLabelFilter(ContextSuggestions.Label)(value);
    },
    [trackAnalytics, applyLabelFilter]
  );

  const handleApplyFolderFilter = useCallback(
    (value: string) => {
      trackAnalytics("Label clicked", { type: ContextSuggestions.Folder });
      applyFilter(ContextSuggestions.Folder, searchContextSuggestionsDictionary)(value);
    },
    [trackAnalytics, applyFilter]
  );

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={context.labels}
        applyLabelFilter={handleApplyLabelFilter}
        applyFolderFilter={handleApplyFolderFilter}
      />
    </TableSimpleCell>
  );
};

export default ContextsTableLabelsCell;
